export default __webpack_public_path__ + "static/media/VolvoNovum-Regular.b76c1e56.woff";